import React from 'react';
import { Input, Select, Icon, Row, Col } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idGrado ?
                                    { key: this.props.filter.idGrado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Grado" />}
                            onChange={(option) => this.props.onChange("idGrado", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.grados.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.cuentaContable ?
                                    { key: this.props.filter.cuentaContable } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Cuenta Contable" />}
                            onChange={(option) => this.props.onChange("cuentaContable", option.key)}
                            optionFilterProp="children"
                            
                        >
                            {this.props.mayorGrado.map(item => (
                                <Select.Option value={item.cuentaContable} key={item.cuentaContable}> {item.cuentaContable}-{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

 {/*                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.cuentaContable} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("cuentaContable", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por Cuenta Contable"
                            autoComplete="off"
                        />
                    </Col> */}
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre}
                            onChange={(e) => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por Nombre"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idMoneda ?
                                    { key: this.props.filter.idMoneda } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Moneda" />}
                            onChange={(option) => this.props.onChange("idMoneda", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.monedas.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
            </div>
        );
    }

}

export default Filters;